import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'TabedLab', 
  description = 'AI-powered spectral and chromatographic analysis. Upload your FTIR or HPLC data and get instant AI-powered insights.',
  keywords = 'spectroscopy, chromatography, FTIR, HPLC, AI analysis, laboratory, scientific analysis',
  image = '/og-image.png',
  url,
  type = 'website',
  noIndex = false
}) => {
  const siteUrl = 'https://tabedlab.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title === 'TabedLab' ? title : `${title} | TabedLab`}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Note: <link rel="canonical"> is managed globally by RouteHead.jsx
          to avoid duplicate canonical tags. Per-page <SEO> overrides only
          title, description, OG and Twitter content. */}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="TabedLab" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:site" content="@tabedlab" />
      
      {/* Additional SEO Tags */}
      <meta name="author" content="TabedLab" />
      <meta name="theme-color" content="#0f172a" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
    </Helmet>
  );
};

export default SEO;
